import { useCallback, useEffect, useState } from "react";
import PendingAuthService from "../../../services/approvals.service";
import { useNavigate } from "react-router";
import { Breadcrumb, Card, Empty, Tabs, Button } from "antd";
import SelectAllCard from "../../../components/pending-approvals/selectAll";
import download from "../../../assests/icons/download_icon.png";
import { AiOutlineLeft } from "react-icons/ai";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import { useTranslation } from "react-i18next";
import ChequeBookRequestCard from "../../../components/pending-approvals/chequeBookRequest";
import LoanRepaymentCard from "../../../components/pending-approvals/loanRepayment";
import DepositsCard from "../../../components/pending-approvals/deposits";
import DepositGridItem from "../../../components/pending-approvals/history-grids/deposit-grid-item";
import DepositListtem from "../../../components/pending-approvals/history-lists/deposit-list-item";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function HistoryDeposits() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const { t } = useTranslation();
  const [layout, setLayout] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setLayout("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    getPendingRecords();
  }, []);

  const getPendingRecords = useCallback(async () => {
    try {
      const response = await PendingAuthService.depositsGetRecords({
        listType: "A",
      });
      if (response.status === 200) {
        setDataSource(response.data);
      }
    } catch (error) {}
  }, []);

  const handleDownload = useCallback(async () => {
    try {
      const reqParams = {
        listType: "A",
      };
      await PendingAuthService.depositsDownload(reqParams);
    } catch (err) {}
  }, []);

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/history")}>
              {t("navigation.history", {
                defaultValue: "History",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("pages.my_accounts.common_my_accounts.deposits", {
                defaultValue: "Deposits",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("pages.my_accounts.common_my_accounts.deposits", {
                defaultValue: "Deposits",
              })}
            </h3>
          </div>
          <div className=" col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
            {dataSource.length === 0 ? null : (
              <Button
                type="default"
                className="btn-primary"
                onClick={handleDownload}
              >
                <img
                  alt="download"
                  src={download}
                  height={20}
                  style={{ paddingRight: "15px" }}
                />
                {t("buttons.download_btn", { defaultValue: "Download" })}
              </Button>
            )}
          </div>
        </div>
      </Card>

      <Card className="application-card">
        {layout === "GRID" && <DepositGridItem dataSource={dataSource} />}
        {layout === "LIST" && <DepositListtem dataSource={dataSource} />}
      </Card>
    </>
  );
}
